export const numberToAbacus = value => {
	const abacus = {
		1: {
			five: false,
			digit: 0,
		},
		10: {
			five: false,
			digit: 0,
		},
		100: {
			five: false,
			digit: 0,
		},
		1000: {
			five: false,
			digit: 0,
		},
		10000: {
			five: false,
			digit: 0,
		},
		100000: {
			five: false,
			digit: 0,
		},
		1000000: {
			five: false,
			digit: 0,
		},
	}

	const dimensions = Object.keys(abacus)
		.map(d => Number(d))
		.sort((a, b) => b - a)

	for (const dimension of dimensions) {
		const intDivider = parseInt(value / dimension)
		if (intDivider > 0) {
			const five = intDivider >= 5
			abacus[dimension] = {
				five,
				digit: five ? intDivider - 5 : intDivider,
			}
		}
		value -= intDivider * dimension
	}

	return abacus
}
